// extracted by mini-css-extract-plugin
export default {"matrix":"matrix-dmogT","scoreCell":"scoreCell-Y5pkO","header":"header-WcH0U"};